import BaseService from './base';
import request from '@/utils/request';

export interface FavoriteViewModel {
  id?: number;
  sourceID?: string;
  sourceType?: number | string;
}

export  class FavoriteService extends BaseService<FavoriteViewModel> {
  protected serviceApi: string = 'Favorite';

  get NewModel(): FavoriteViewModel {
    return {
      id: 0,
      sourceID: '',
    };
  }

  public IsFavorited(id: string, type: number) {
    return request({
      url: `${this.serviceApi}/IsFavorited/${id}/${type}`,
      method: 'get',
    });
  }
}
